import { render, staticRenderFns } from "./manage-seller-groups.modal.vue?vue&type=template&id=0ea88756&scoped=true"
import script from "./manage-seller-groups.modal.vue?vue&type=script&lang=js"
export * from "./manage-seller-groups.modal.vue?vue&type=script&lang=js"
import style0 from "./manage-seller-groups.modal.vue?vue&type=style&index=0&id=0ea88756&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea88756",
  null
  
)

export default component.exports